<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-row>
      <v-col cols="12">
        <header-big :title="$t('HomePage.header.summary')"></header-big>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" sm="12">
        <workflow-summary :files="files" :revoked="revoked" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "../../i18n";
import HeaderBig from "../../components/ui/text/HeaderBig";
import WorkflowSummary from "./Summary";
import { log } from "@/helpers/logger";

export default {
  name: "workflow-summary-page",
  title: i18n.t("HomePage.header.summary"),
  components: {
    WorkflowSummary,
    HeaderBig,
  },
  data() {
    return {
      workflow: {},
      files: [],
      revoked: false,
    };
  },
  computed: {
    currentWorkflow() {
      return this.$store.state.auth.workflow;
    },
  },
  watch: {
    selected() {
      this.$emit("selectionChange", this.selected);
    },
  },
  created: async function () {
    this.revoked = this.$store.state.data.revoked;
    this.workflow = this.currentWorkflow;
    this.color = this.$vuetify.theme.themes.light.primary;

    await this.$store
      .dispatch("data/getSummaryFiles")
      .then(async (data) => {
        log(
          "SummaryPage.index.created() - get files for workflow " +
            this.workflow.workflow_id,
          "info"
        );
        this.files = data;
      })
      .catch((err) => {
        log("SummaryPage.index.created() - " + err, "error");
      });
  },
};
</script>